import {Component} from '@angular/core';
import {BaseSupportModalComponent} from "./base_support.component";

@Component({
	templateUrl: './transfer_invoice.component.html'
})
export class TransferInvoiceModalComponent extends BaseSupportModalComponent {
	domainUrl: string;
	siteId: string;
	invoiceNumber: string = '';
	dateTo: string = '';
	tariffId: string = '';
	sites: any[] = [];
	userSite: string = '';
	anotherSite: string = '';
	mitsFilter: string = 'userSite';
	recurrentProfile = '';

	async ok() {
		if (confirm(`Вы уверены, что хотите перенести оплату с сайта ${this.domainUrl}?`)) {
			await this.supportService.transferInvoice(this.siteId, this.userSite, this.mitsFilter, this.anotherSite, this.spreader.base.comment).toPromise();

			this.execute();
		}
	}
}
